import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const OwnershipCellDisplay = ({ value }: { value: any }) => {
  const { t } = useTranslation('@cibo/landmanager/OwnershipEditor')
  if (!value) return null

  const { yearsInOperation, operatorIsOwner } = value.input || {}

  return (
    <Stack>
      {!!Object.prototype.hasOwnProperty.call(value.input, 'operatorIsOwner') && (
        <Typography>{t(operatorIsOwner ? 'owned' : 'rented')}</Typography>
      )}

      {!!Object.prototype.hasOwnProperty.call(value.input, 'yearsInOperation') && (
        <Typography variant="body2" color="text.secondary">
          {t('yearsInOperation', { count: yearsInOperation })}
        </Typography>
      )}
    </Stack>
  )
}

export const OwnershipCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const detail = params.row.findDetail({ traitId, year })
  return <OwnershipCellDisplay value={detail} />
}
